import { render, staticRenderFns } from "./App.vue?vue&type=template&id=25930e97&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=25930e97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25930e97",
  null
  
)

export default component.exports